import { getBasePath } from '@experiences/util';
import urljoin from 'url-join';

export const getOrganizationStandardUrl = () => urljoin(window.location.origin, getBasePath());
